import type { FC } from "react";
import { useEffect, useRef, useState } from "react";
import { allTrackers } from "app/services/track/track";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { Dropdown, DropdownButton } from "@similarweb/ui-components";
import type { CategoryId, ICategory } from "app/common/services/categoryService.types";
import { translate } from "app/filters/i18nFilter";
import { CategoriesFilter } from "pro-features/components/filtersPanel/src/CategoriesFilter";
import { findCategoryById } from "app/common/keyword-research/serp-players/categoryUtils";

interface ICategoriesDashboardFilter {
    categories: ICategory[];
    customCategories: ICategory[];
    onSelect: (category: ICategory) => void;
    selectedCategory?: CategoryId;
}

export const CategoriesDashboardFilter: FC<ICategoriesDashboardFilter> = ({
    categories = [],
    customCategories = [],
    onSelect,
    selectedCategory,
}) => {
    const [selectedFilter, setSelectedFilters] = useState<ICategory>();
    const dropDownRef = useRef(null);

    const updateCategories = (categoryId: CategoryId, categoryList: ICategory[]) => {
        if (categoryId && categoryList?.length > 0) {
            const selectedCategory = findCategoryById(categoryList, categoryId);
            if (selectedCategory) {
                setSelectedFilters(selectedCategory);
            }
        }
    };

    useEffect(() => {
        updateCategories(selectedCategory, categories);
        updateCategories(selectedCategory, customCategories);
    }, [selectedCategory, customCategories, categories, selectedFilter]);

    const handleCategoriesFilterOpened = (isOpened: boolean) => {
        if (isOpened) {
            allTrackers.dispatchTrackEvent("Drop Down", "open", "Category/filter opened");
        }
    };
    const onCategorySelected = (selectedCategory: ICategory) => {
        dropDownRef.current.closePopup();
        setSelectedFilters(selectedCategory);
        onSelect(selectedCategory);
    };

    return (
        <FlexColumn>
            <Dropdown
                ref={dropDownRef}
                width={379}
                closeOnItemClick={true}
                onToggle={handleCategoriesFilterOpened}
                cssClassContainer={"Popup-content-industry-filter"}
            >
                {[
                    <DropdownButton
                        key="DropdownButton1"
                        cssClass="DropdownButton--has-value"
                    >
                        {selectedFilter?.text || translate("keywords.analysis.filters.categories.button")}
                    </DropdownButton>,
                    <CategoriesFilter
                        categories={categories}
                        customCategories={customCategories}
                        onItemClickCallback={onCategorySelected}
                    />,
                ]}
            </Dropdown>
        </FlexColumn>
    );
};
